import classnames from "classnames";

import { ToastAdditionalContent } from "./ToastAdditionalContent";
import stylesAdditional from "./ToastAdditionalContent.module.scss";
import { ToastContact } from "./ToastContact";
import styles from "./ToastContactAdditionalOptionsBelow.module.scss";
import { ToastContent } from "./ToastContent";
import { ToastRoot } from "./ToastRoot";
import stylesContact from "./ToastWithContactPerson.module.scss";

export const ToastContactAdditionalOptionsBelow = (props) => {
  const { isWarning, className, onClick, disabled, additionalOptions } = props;

  return (
    <ToastRoot isWarning={isWarning} className={className}>
      <div className={styles.main}>
        <div className={stylesContact.content}>
          <ToastContent {...props} />
          <ToastContact className={stylesContact.contact} />

          {onClick && (
            <div
              onClick={onClick}
              className={classnames(stylesAdditional.closeBtn, {
                [stylesAdditional.cursorDefault]: disabled,
                [stylesAdditional.cursorPointer]: !disabled,
                [stylesAdditional.closeButtonWarning]: isWarning,
                [stylesAdditional.closeButtonPrimary]: !isWarning,
              })}
            >
              &times;
            </div>
          )}
        </div>

        <div className={styles.options}>
          {additionalOptions?.map(({ text, action }, idx) => (
            <ToastAdditionalContent
              key={`option-${idx}`}
              innerText={{ subtitle: text }}
              additional={action}
              excludeIcon
            />
          ))}
        </div>
      </div>
    </ToastRoot>
  );
};
